module.exports = __webpack_public_path__ + "img/icon-customer-service-title.svg";